@if (user()) {
  <section class="avatar-popover">
    <div class="avatar-popover__user-content">
      <app-avatar color="green" size="m" type="initials" [name]="user()?.displayName || ''" />
      <div class="avatar-popover__user-details">
        <p class="avatar-popover__user-detail color--n-night">{{ user()?.displayName }}</p>
        <p class="avatar-popover__user-detail color--n-100">{{ user()?.email }}</p>
      </div>
    </div>

    <app-user-roles />

    @if (aliasFeatureEnabled()) {
      <div class="avatar-popover__alias">
        <div class="flex__align-center width-100">
          <div class="avatar-popover__alias-link avatar-popover__clickable" (click)="navigateToAlias()">
            <mat-icon svgIcon="user--multiple" class="avatar-popover__icon" size="18px" />
            <a class="avatar-popover__list-title" [title]="aliasTitle()">{{ aliasTitle() }}</a>
          </div>
          @if (aliasTitle() !== 'Alias') {
            <button mat-icon-button class="avatar-popover__alias-clear" (click)="clearAlias()">
              <mat-icon svgIcon="close" size="18px" />
            </button>
          }
        </div>
      </div>
    }

    <div class="avatar-popover__list avatar-popover__clickable" (click)="logout()">
      <mat-icon svgIcon="logout" size="18px" class="avatar-popover__icon" />
      <p class="avatar-popover__list-title">Sign out</p>
    </div>

    <div class="avatar-popover__version-content">
      <a
        class="font-size--three-quarters color--b-dark"
        href="https://ada-apps-akersolutions.atlassian.net/wiki/external/NGVkNzYzYjQzZTgwNDZjOTljZDk0NjQ1ODUxNzRjYTc"
        target="_blank"
      >
        {{ appVersion() }}
      </a>

      <span class="font-size--three-quarters color--n-100">
        {{ buildTime() | date: 'dd-MMM-YYYY HH:mm' }}
      </span>
    </div>
  </section>
}
